import { render, staticRenderFns } from "./params.vue?vue&type=template&id=dced5172&scoped=true&"
import script from "./params.vue?vue&type=script&lang=ts&"
export * from "./params.vue?vue&type=script&lang=ts&"
import style0 from "./params.vue?vue&type=style&index=0&id=dced5172&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dced5172",
  null
  
)

export default component.exports